import to from 'await-to-js';

export const renderAssemblyJs = () => {
  const script = document.createElement('script');
  script.async = true;
  const promisepay = document.getElementById('promisepay-script');
  if (promisepay == null) {
    if (ENVIRONMENT === 'production') {
      script.id = 'promisepay-script';
      script.src = 'https://js.promisepay.com/PromisePay.js';
    } else {
      script.id = 'promisepay-script';
      script.src = 'https://js.prelive.promisepay.com/PromisePay.js';
    }
    document.body.appendChild(script);
  }
};
export const createCreditCardInAssemblyWrapper = (payload) => new Promise((resolveResponse, resolveError) => {
  promisepay.createCardAccount(
    payload.cardToken,
    {
      full_name: payload.fullName,
      number: payload.number,
      expiry_month: payload.expiryMonth,
      expiry_year: payload.expiryYear,
      cvv: payload.cvc,
    },
    (response) => resolveResponse(response),
    (error) => {
      resolveError(error);
    },
  );
});

export const createCreditCardInAssembly = async (payload) => {
  const [creditCardError, creditCard] = await to(
    createCreditCardInAssemblyWrapper(payload),
  );
  return [creditCardError, creditCard];
};

// export const createCreditCardInAssembly = (payload) => new Promise((resolveResponse, resolveError) => {
//   try {
//     console.log('attempt');
//     promisepay.createCardAccount(
//       payload.cardToken,
//       {
//         full_name: payload.fullName,
//         number: payload.number,
//         expiry_month: payload.expiryMonth,
//         expiry_year: payload.expiryYear,
//         cvv: payload.cvc,
//       },
//       (response) => resolveResponse(response),
//       (error) => {
//         console.log('error2');
//         console.log(error);
//         resolveResponse(error);
//       },
//     );
//   } catch (e) {
//     console.log('error');
//     console.log(e);
//   }
// });

export default null;
